import Actions from "../action";

const initialState = {
    isLoading: false,
    hostel_report: undefined,
    error: false
}
const HostelReportReducer = (state = initialState, action = {}) => {
    switch (action.type) {
    
        case Actions.HOSTEL_REPORT: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case Actions.HOSTEL_REPORT_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                hostel_report: action.data?.response || [],
                error: false
            };
        }
        case Actions.HOSTEL_REPORT_FAILURE: {
            return {
                ...state,
                isLoading: false,
                hostel_report: undefined,
                error: true,
            };
        }

        case Actions.CLEAR_HOSTEL_REPORT: {
            return {
                ...state,
                isLoading: false,
                hostel_report: [],
               
            };
        }
        default:
            return state;
    }
};
export const getHostelReportList = (state) => state?.HOSTEL_REPORT?.hostel_report;


export default HostelReportReducer;